import React from "react";
import {useTranslation} from "react-i18next";
import {TableTitle} from "./PlatformDeliveryDetailTable.styles";
import {Table, Tooltip} from "antd";
import moment from "moment";
const {Column} = Table;
export const PlatformDeliveryDetailTable = ({orders}) => {
    const {t} = useTranslation();
    return (
        <>
            <TableTitle>{t("other.platformDetail", {ns: "common"})}</TableTitle>
            <Table rowKey="_id" dataSource={orders} pagination={false}>
                <Column
                    title={t("other.platformPickingTime", {ns: "common"})}
                    render={order =>
                        moment.utc(order.platformPickingTime).format("DD-MM-YYYY HH:mm")
                    }
                />
                <Column
                    title={t("other.platformDeliveryTime", {ns: "common"})}
                    render={order =>
                        moment.utc(order.platformDeliveryTime).format("DD-MM-YYYY HH:mm")
                    }
                />
                <Column
                    title={t("fields.orderNumber", {ns: "common"})}
                    dataIndex="orderNumber"
                    render={orderNumber => (
                        <Tooltip placement="topLeft" title={orderNumber}>
                            {orderNumber}
                        </Tooltip>
                    )}
                    ellipsis={{showTitle: false}}
                    width={170}
                />
                <Column
                    title={""}
                    render={order =>
                        order.isPlatformSlotOrder
                            ? t("other.platformSlotDelivery", {
                                  ns: "common"
                              })
                            : t("other.platfromQuickDelivery", {
                                  ns: "common"
                              })
                    }
                />
            </Table>
        </>
    );
};
